module.exports = __webpack_public_path__ + "static/media/accept_email_invite.5b609e25.svg";